﻿import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { GruposEmpresas } from "../GruposEmpresas/GruposEmpresas";

const columns = () =>
(
    {
        c_empresa_id: new EntityColumn<string>({ name: 'c_empresa_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Empresa ID' }),
        vc_nombreempresa: new EntityColumn<string>({ name: 'vc_nombreempresa', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre' }),
        vc_razonsocial: new EntityColumn<string>({ name: 'vc_razonsocial', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Razón social' }),
        c_grupoempresa_id: new EntityColumn<string>({ name: 'c_grupoempresa_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Grupo' }),
        c_cuit_id: new EntityColumn<string>({ name: 'c_cuit_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Cuit' }),

        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        empr_brwStandard: { name: 'empr_brwStandard', keyMappings: { c_empresa_id: 0, c_grupoempresa_id: -1 } },
        empr_brwPorGrupo: { name: 'empr_brwPorGrupo', keyMappings: { c_empresa_id: 0, c_grupoempresa_id: -1 } },
    }
)


const lookups = () =>
(
    {
        'GruposEmpresas': {
            name: 'GruposEmpresas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new GruposEmpresas(client, parentKeys)
        }
    }
)

export class EmpresasDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('Empresas');
    }
}